<template>
    <div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh" style="padding-bottom:20px">
            <van-list v-model:loading="loading" v-model:error="error" error-text="请求失败，点击重新加载" :finished="finished" @load="onLoad">
                <div class="OwnersCard" v-for="item in list" :key="item" @click="openVoting(item)">
                    <van-cell-group :border='false'>
                    <van-cell :value='item.startPublicityDate' is-link :border='false'>
                        <template #title>
                        <span class="customTile">{{item.reqName}}</span>
                        </template>
                    </van-cell>
                    </van-cell-group>
                    <van-row>
                    <van-col span='15' style="font-size:14px;padding-left:10px;color: rgb(67, 67, 161);font-weight:bold">{{item.voteState=='1'?'公示中':item.voteState=='2'?'投票中':item.voteState=='3'?'投票结束':''}}</van-col>
                    <!-- <van-col span='7' style="font-size:14px;color: rgb(67, 67, 161);font-weight:bold" offset="2">{{item.voteState=='1'?'公示中':item.voteState=='2'?'投票中':item.voteState=='3'?'投票结束':''}}</van-col> -->
                    </van-row>
                </div>
            </van-list>
        </van-pull-refresh>
        <div v-if="isShow" style="margin-top:15px;font-size:14px;text-align:center;color:#e0e0e0">暂无数据</div>
    </div>
</template>

<script>
export default {
    data(){
        return{
            isShow:false,
            refreshing:false,
            error: false,
            loading:false,
            finished:false,
            list: [],
        }
    },
    methods:{
        onLoad(){
            let data = {
                projectType:1,
                pageNum:1,
                pageSize:100
            }
            this.$postQuery('/weChatNotice/getWeChatReqList', data).then((response) => {
                if (this.refreshing) {
                    this.list = [];
                    this.refreshing = false;
                }
                if(response.code==200){
                    this.list = response.data.list;
                    if(this.list.length==0){
                        this.isShow=true
                    }
                    this.list.forEach((item)=>{
                        if(item.startPublicityDate){
                            item.startPublicityDate = item.startPublicityDate.substring(0,10)
                        }
                    })
                    this.loading = false;
                    if (this.list.length >= response.data.list.length) {
                        this.finished = true;
                    }
                }
            })
            .catch(()=>{
                this.loading = false;
                this.error = true;
            })
        },
        onRefresh(){
            // 清空列表数据
            this.finished = false;
            //重新加载数据
            this.loading = true;
            this.onLoad();
        },
        openVoting(item){
            console.log(item.id)
            this.$router.push({
                path:'/EmergencyPublicity',
                query:{
                    id:item.id,
                    thatName:item.reqName,
                    startPublicityDate:item.startPublicityDate
                }
            })
        }
    }
}
</script>

<style scoped>
.OwnersCard{
  margin:5px 12px;
  box-shadow:-3px 3px 20px 3px #ebedf0;
  border: 1px solid white;
  border-radius: 5px;
}
.customTile{
  display:inline-block;
  width: 150px;
  overflow: hidden; /*超出部分隐藏*/
  text-overflow: ellipsis; /* 超出部分显示省略号 */
  white-space: nowrap; /*规定段落中的文本不进行换行 */
}
</style>